<template>
  <b-container class="view-report-container" fluid>
    <report-view
      v-if="!loading"
      :value="reportData"
      :chart-toolbox="false"
      :loading="chartLoading"
      @refresh-chart="getReportView($event, true)"
    >

      <b-button
        slot="chart-header-buttons"
        variant="outline-secondary"
        class="mr-0 mr-md-2 my-2"
        @click="showHelpModal"
      >
        <span class="far fa-bookmark mr-2" />
        {{ $t('reports.oscillography.view-report.legend') }}
      </b-button>
      <s-loading-button
        slot="chart-header-buttons"
        variant="outline-green"
        class="mr-0 mr-md-2 my-2"
        @click="exportXlsx"
      >
        <span class="fas fa-file-excel mr-2" />
        {{ $t('buttons.excel-export') }}
      </s-loading-button>
    </report-view>
    <help-modal ref="helpModal" />
    <s-loader
      v-if="loading"
      class="mt-5"
      size="lg"
    />
  </b-container>
</template>
<script>
import OscillographyService from '@/domain/services/generalPanel/reports/oscillography';
import ReportView from '@/domain/components/generalPanel/reports/oscillography';
import HelpModal from '@/domain/components/generalPanel/reports/oscillography/helpModal';
import loadingMixIn from '@/services/loadingMixin';

export default {
  components: {
    ReportView,
    HelpModal,
  },
  mixins: [
    loadingMixIn,
  ],
  data: () => ({
    reportData: {},
    maneuvers: [],
    chartLoading: false,
  }),
  computed: {
    reportId() {
      return this.$route.params.reportId;
    },
  },
  created() {
    this.getReportView();
  },
  mounted() {
    if (this.$route.query?.isNew) {
      this.$pushAlert({ code: 'MS011' });
      this.$router.push(this.$route.path);
    }
  },
  methods: {
    getReportView(chartFilter, chartLoading) {
      if (!chartLoading) {
        this.startLoading();
      }
      this.chartLoading = chartLoading;
      return OscillographyService.getReportView(
        this.reportId,
        chartFilter,
      ).then((reportData) => {
        this.reportData = reportData;
      }).finally(() => {
        this.endLoading();
        this.chartLoading = false;
      });
    },
    exportXlsx({ wait }) {
      wait(OscillographyService.downloadReport(this.reportId));
    },
    showHelpModal() {
      this.$refs.helpModal.show();
    },
  },
};
</script>

<style lang="sass" scoped>
  .view-report-container
    overflow: hidden
</style>
